import { useState, type ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { useIsMobile } from '@/hooks/useIsMobile'

interface CollapsibleCardProps {
  id?: string
  headerContent: ReactNode
  headerClassName?: string
  children: ReactNode
  cardClassName?: string
  defaultExpanded?: boolean
}

export function CollapsibleCard({
  id,
  headerContent,
  headerClassName,
  children,
  cardClassName,
  defaultExpanded = false,
}: CollapsibleCardProps) {
  const isMobile = useIsMobile()
  const [expanded, setExpanded] = useState(defaultExpanded)

  if (!isMobile) {
    return (
      <Card id={id} className={cardClassName}>
        <CardHeader className={headerClassName}>{headerContent}</CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    )
  }

  return (
    <Card id={id} className={cardClassName}>
      <CardHeader
        className={`cursor-pointer ${headerClassName || ''}`}
        onClick={() => setExpanded((v) => !v)}
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex-1">{headerContent}</div>
          <ChevronDown
            className={`h-5 w-5 text-muted-foreground transition-transform duration-200 ${
              expanded ? 'rotate-180' : ''
            }`}
          />
        </div>
      </CardHeader>
      {expanded && <CardContent>{children}</CardContent>}
    </Card>
  )
}
